import React, { Component } from 'react';
import LeadDates from '../../components/leadtracker/LeadDates';
import { Button } from '@blueprintjs/core';
import InputText from '../../components/blueprintWrappers/InputText';

class NewLead extends Component {

	render() {

		const { leadDateProps, onChange, setComplete, setIncomplete, complete, save, goBack } = this.props;

		return (
			<div >
				<div>
					Company Name
					</div>
				<InputText
					placeholder="..."
					onChange={(text) => onChange(text, 'companyName')}
				/>

				<div >
					First Name
					</div>

				<InputText
					placeholder="..."
					onChange={(text) => onChange(text, 'contactFirstName')}
				/>

				<div >
					Last Name
					</div>

				<InputText
					placeholder="..."
					onChange={(text) => onChange(text, 'contactLastName')}
				/>

				<div >
					Contact Phone
					</div>
				<InputText
					placeholder="..."
					onChange={(text) => onChange(text, 'contactPhone')}
				/>

				<div >
					Contact Email
					</div>
				<InputText
					placeholder="..."
					onChange={(text) => onChange(text, 'contactEmail')}
				/>

				<div >
					Contact Notes
					</div>
				<InputText
					placeholder="..."
					onChange={(text) => onChange(text, 'contactNotes')}
				/>

				<div >
					Action Item
					</div>
				<InputText
					placeholder="..."
					onChange={(text) => onChange(text, 'actionItem')}
				/>

				<div >
					Details
					</div>
				<InputText
					placeholder="..."
					onChange={(text) => onChange(text, 'details')}
				/>

				<LeadDates {...leadDateProps} />

				<div>
					<Button /* TODO styling or toggle effect */
						onClick={setComplete}
						label="Complete"
						className={complete === 'Y' ? 'pt-intent-success' : 'pt-intent-danger'}

					> Complete
					</Button>
					<Button
						onClick={setIncomplete}
						label="Not Complete"
						className={complete === 'N' ? 'pt-intent-success' : 'pt-intent-danger'}

					> Not Complete
					</Button>

					<Button onClick={save} >
						Save
					</Button>

					<Button onClick={goBack} >
						Cancel
					</Button>
				</div>
			</div>

		);
	}
}
export default NewLead;


// WEBPACK FOOTER //
// ./src/components/leadtracker/NewLead.js